import RequestAbstract from "./RequestAbstract";

export default class Users extends RequestAbstract {
    get link() {
        return this.links.users;
    }

    async getMeta() {
        return await this.post(this.link + "/meta-info");
    }

    async updatePassword(obj) {
        return await this.post(this.link + "/update-password", obj);
    }
}
